import React from 'react';
import './styles.css';

const variants = {
  h1: 'text-h1',
  h2: 'text-h2',
  h3: 'text-h3',
  body1: 'text-body1',
  body2: 'text-body2',
  body: 'text-body1',
  bodyLarge: 'text-bodyLarge',
  caption: 'text-caption',
  captionLarge: 'text-captionLarge'
};

const weights = {
  normal: 'text-normal',
  medium: 'text-medium',
  bold: 'text-bold'
};

export const variantStyles = {
  h1: {
    fontSize: 'xxl',
    fontWeight: 'bold',
  },
  h2: {
    fontSize: 'xl',
    fontWeight: 'bold',
  },
  h3: {
    fontSize: 'lg',
    fontWeight: 'bold',
  },
  body: {
    fontSize: 'md',
    fontWeight: 'normal',
  },
  bodyLarge: {
    fontSize: 'md',
    fontWeight: 'normal',
    transform: 'scale(1.06)',
  },
  caption: {
    fontSize: 'sm',
    fontWeight: 'normal',
  },
  captionLarge: {
    fontSize: 'md',
    fontWeight: 'normal',
    color: 'var(--color-text-secondary)',
  },
};

export const Text = ({
  children,
  variant = 'body1',
  weight = 'normal',
  color,
  className = '',
  as,
  ...props
}) => {
  const Component = as || {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    body: 'p',
    body1: 'p',
    body2: 'p',
    bodyLarge: 'p',
    caption: 'span',
    captionLarge: 'span'
  }[variant] || 'span';

  const classes = [
    'text',
    variants[variant] || `text-${variant}`,
    weights[weight],
    className
  ].filter(Boolean).join(' ');

  const style = color ? { color } : {};

  return (
    <Component className={classes} style={style} {...props}>
      {children}
    </Component>
  );
}; 